import { render, staticRenderFns } from "./postPreviewHeader.vue?vue&type=template&id=6ece794c&"
import script from "./postPreviewHeader.vue?vue&type=script&lang=js&"
export * from "./postPreviewHeader.vue?vue&type=script&lang=js&"
import style0 from "./postPreviewHeader.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports